<script>
import {mapActions} from "vuex";
import PrefectureList from '../../../../../mixins/PrefectureList'
import ZipCodeSearch from '../../../../../components/ZipCodeSearch'
import SearchZipModal from "../../../../components/SearchZipModal.vue";

export default {
  name: "DriverMasterGeneralWasteDisposalTraderBlock",
  components: {
    ZipCodeSearch,
    SearchZipModal
  },
  mixins: [
    PrefectureList
  ],
  props: {
    targetTraderId: {
      type: [String, Number],
      default: () => null,
    },
  },
  computed: {},
  watch: {
    targetTraderId: {
      handler (newId) {
        if (newId) {
          this.searchGeneralWasteDisposal()
        }
      },
      immediate: true,
    },
  },
  data () {
    return {
      form: null,
      enableSearchZipModal: false,
    }
  },
  created() {
    if (!this.targetTraderId) {
      this.newGeneralWasteDisposal().then((content) => {
        this.form = content;
      })
    }
  },
  methods: {
    ...mapActions("DriverMasterGeneralWasteDisposal", {
      editGeneralWasteDisposal: "edit",
      newGeneralWasteDisposal: "new",
      storeGeneralWasteDisposal: "create",
      updateGeneralWasteDisposal: "update",
      deleteGeneralWasteDisposal: "destroy",
    }),
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit("closeCallback")
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          if (this.targetTraderId) {
            this.update();
          } else {
            this.store();
          }
        }
      })
    },
    /**
     * 新規登録を行い、親画面にコールバック
     */
    store () {
      this.storeGeneralWasteDisposal({ params: this.form }).then((content) => {
        this.$emit("registerCallback", content.id)
      })
    },
    /**
     * 更新登録を行い、親画面にコールバック
     */
    update () {
      this.updateGeneralWasteDisposal({ id: this.targetTraderId, params: this.form}).then(() => {
        this.$emit("registerCallback", null)
      })
    },
    /**
     * 郵便番号検索 コールバック
     * @param content
     */
    zipAddressCallback (content) {
      this.form.prefecture_code = `${content.pref_code}`
      this.form.address_1 = `${content.locality}`
      this.form.address_2 = `${content.street}`
    },
    /**
     * 一般廃棄物処分業者を検索する
     */
    searchGeneralWasteDisposal () {
      this.editGeneralWasteDisposal({ id: this.targetTraderId }).then((content) => {
        this.form = content;
      })
    },
    closeModalCallback () {
      this.enableSearchZipModal = false;
    },
    /**
     * 郵便番号検索反映ボタン コールバック
     * @param address { Object }
     * @property address.zip_code { string } 郵便番号
     * @property address.prefecture_code { number } 都道府県コード
     * @property address.city { string } 市区町村
     * @property address.town { string } 町域
     */
    searchZipReflectCallback (address) {
      this.form.zip_code = address.zip_code
      this.form.prefecture_code = `${address.prefecture_code}`
      this.form.address_1 = address.city
      this.form.address_2 = address.town
    },
    /**
     * 住所→郵便場号 コールバック
     * @param zipCode { string } 郵便番号
     */
    searchZipReflectZipCallback (zipCode) {
      this.form.zip_code = zipCode;
    },
  },
}
</script>

<template>
  <div>
    <validation-observer
      ref="observer"
    >
      <v-card
        flat
      >
        <v-card-text
          v-if="form"
          class="pt-2"
        >
          <!-- 事業者コード -->
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="事業者コード"
                rules="required|alpha_num_only|max:10"
              >
                <v-text-field
                  v-model="form.code"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="事業者コード"
                  outlined
                  persistent-placeholder
                  placeholder="例）N001"
                >
                  <template v-slot:label>
                    <span>事業者コード</span>
                    <span class="ml-1">
                      ({{ form.code?.length || 0 }} / 10)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>

            </v-col>
            <v-col
              cols="12"
              md="6"
              style="vertical-align: middle"
            >
              最近使用したコード:&nbsp;<strong>{{ form.recent_registered_codes }}</strong>
            </v-col>
          </v-row>
          <!-- /事業者コード -->

          <!-- 事業者名 -->
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="requiredMark"
                name="事業者名"
                rules="required|max:60"
              >
                <v-text-field
                  v-model="form.name"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="事業者名"
                  outlined
                  persistent-placeholder
                  placeholder="例）○○○○　株式会社"
                >
                  <template v-slot:label>
                    <span>事業者名</span>
                    <span class="ml-1">
                      ({{ form.name?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /事業者名 -->

          <!-- 郵便番号 -->
          <v-row>
            <v-col
              cols="12"
              md="5"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{zip_code: true, required: true, max:8 }"
                class="requiredMark"
                name="郵便番号"
              >
                <v-text-field
                  v-model="form.zip_code"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  hint="ハイフンを含めて入力してください"
                  label="郵便番号"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）111-1111"
                  required
                >
                  <template v-slot:label>
                    <span>郵便番号</span>
                    <span class="ml-1">
                      ({{ form.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append-outer>
                    <zip-code-search
                      :zip-code="form.zip_code"
                      @zipAddress="zipAddressCallback"
                    />
                    &nbsp;
                    <v-btn
                      outlined
                      small
                      @click="searchZipButtonClickEvent"
                    >
                      住所→郵便番号
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /郵便番号 -->

          <!-- 都道府県／市区町村 -->
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="都道府県"
                class="requiredMark"
              >
                <v-autocomplete
                  v-model="form.prefecture_code"
                  :error-messages="errors"
                  :items="prefList"
                  dense
                  hide-details="auto"
                  item-text="text"
                  item-value="value"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                  required
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                rules="required|full_width|max:20"
                name="市区町村"
                class="requiredMark"
              >
                <v-text-field
                  v-model="form.address_1"
                  :error-messages="errors"
                  dense
                  label="市区町村"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区"
                  required
                >
                  <template v-slot:label>
                    <span>市区町村</span>
                    <span class="ml-1">
                      ({{ form.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /都道府県／市区町村 -->

          <!-- 町域 -->
          <v-row>
            <v-col
              cols="12"
              md="9"
            >
              <validation-provider
                v-slot="{ errors }"
                name="町域"
                rules="full_width|max:40"
              >
                <v-text-field
                  v-model="form.address_2"
                  :error-messages="errors"
                  dense
                  label="町域"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）日本橋兜町"
                >
                  <template v-slot:label>
                    <span>町域</span>
                    <span class="ml-1">
                      ({{ form.address_2?.length || 0 }} / 40)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /町域 -->

          <!-- 詳細住所 -->
          <v-row>
            <v-col
              cols="12"
              md="9"
            >
              <validation-provider
                v-slot="{ errors }"
                name="詳細住所"
                rules="max:50"
              >
                <v-text-field
                  v-model="form.address_3"
                  :error-messages="errors"
                  dense
                  label="詳細住所"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）１−２−３　○○ビル○階"
                >
                  <template v-slot:label>
                    <span>詳細住所</span>
                    <span class="ml-1">
                      ({{ form.address_3?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /詳細住所 -->

          <!-- 電話番号 -->
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="電話番号"
                :rules="{ numeric_hyphen_only: true,min: 2, max: 15 }"
              >
                <v-text-field
                  v-model="form.phone_number"
                  :error-messages="errors"
                  dense
                  label="電話番号"
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span>電話番号</span>
                    <span class="ml-1">
                      ({{ form.phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /電話番号 -->

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            type="button"
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="!form"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
    </v-card>
    </validation-observer>

    <!-- 郵便番号検索モーダル -->
    <search-zip-modal
      :enable="enableSearchZipModal"
      :initial-prefecture-code="form.prefecture_code"
      :initial-city-name="form.address_1"
      :initial-town-name="form.address_2"
      @reflectFullCallback="searchZipReflectCallback"
      @reflectZipCallback="searchZipReflectZipCallback"
      @closeCallback="closeModalCallback"
    />
    <!-- /郵便番号検索モーダル -->

  </div>
</template>

<style scoped lang="scss">

</style>
